import React from 'react';
import ProductoList from "./ProductoList";

function ProductosPage() {
  return (
    <div className="container mt-4">
      <ProductoList />
    </div>
  );
}

export default ProductosPage;
